import moment from 'moment';
import { defaultTTranslate } from 'src/constants/main';
import {
  BRANCHES_SELECTION,
  ICashbackFilter,
  ICashbackValidationErrors,
  IEditCashback,
} from 'src/view/screens/MarketingScreen/screens/Cashback/types/cashback';
import { fullWeek } from '~/constants/dateTime';

export const defaultCashback: IEditCashback = {
  id: 0,
  created_at: null,
  delayed_credit: 'hours',
  delayed_credit_period: '0',
  deleted_at: null,
  description: defaultTTranslate,
  branches: [],
  branchesSelection: BRANCHES_SELECTION.ALL,
  order_types: [],
  // time
  start_time: undefined,
  end_time: undefined,
  all_day: undefined,
  // date
  start_day: undefined,
  end_day: undefined,
  days_of_week: fullWeek,
  //
  max_cashback: '0',
  name: defaultTTranslate,
  percent: '0',
  updated_at: null,
  validity: 'days',
  validity_period: '0',
  state: 1,
  highest_priority: 1,
  //
  isExpired: false,
  isActiveLimitReached: false,
};

export const defaultCashbackFilter: ICashbackFilter = {
  search: undefined,
};

export const defaultCashbackValidation: ICashbackValidationErrors = {
  nameEn: null,
  nameAr: null,
  descriptionEn: null,
  descriptionAr: null,
  date: null,
  percent: null,
  balanceValidityPeriod: null,
  orderTypes: null,
};

export const defaultDate = {
  start: moment()
    .set({
      hours: 0,
      minutes: 0,
      seconds: 0,
    })
    .toDate(),
  end: moment()
    .set({
      hours: 23,
      minutes: 59,
      seconds: 59,
    })
    .toDate(),
};
